import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import React, { useEffect } from 'react';

import { findAllCashiersAction } from 'redux/casher/casher.action';
import { CashierSelector } from 'redux/casher/casher.selector';

import { CashCard } from './CashierCard';
import CashierCardLoader from './CashierCardLoarder';

export const AdminCash = () => {
  const dispatch = useAppDispatch();
  const { cashiers: cashUsers, loading: isLoading } =
    useAppSelector(CashierSelector);

  useEffect(() => {
    dispatch(findAllCashiersAction());
  }, [dispatch]);
  return (
    <>
      {isLoading ? (
        <CashierCardLoader />
      ) : (
        cashUsers.map((casher, index) => (
          <CashCard
            key={index}
            cashIndex={index.toString()}
            casherInfo={casher}
          />
        ))
      )}
    </>
  );
};

export default AdminCash;
